import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// Extend tailwind-merge to recognize custom typography classes as fontSize utilities
// This prevents conflicts between custom typography (text-label-lg) and colors (text-white-100)
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        // Display typography
        'text-display-lg', 'text-display-md', 'text-display-sm',
        // Heading typography
        'text-heading-xl', 'text-heading-lg', 'text-heading-md', 'text-heading-sm', 'text-heading-xs',
        // Body typography
        'text-body-lg', 'text-body-md', 'text-body-sm', 'text-body-xs',
        // Label typography
        'text-label-lg', 'text-label-md', 'text-label-sm', 'text-label-xs',
        // Stat typography
        'text-stat-xl', 'text-stat-lg', 'text-stat-md', 'text-stat-sm',
        // Caption typography
        'text-caption',
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
